module.exports = __webpack_public_path__ + "static/media/pp.38c77bb6.png";